import { useEffect, type ReactNode} from "react";
import { Helmet } from "react-helmet-async";

type Props = {
  children?: ReactNode;
};

export function TwaShell({ children }: Props) {
  useEffect(() => {
    if ("serviceWorker" in navigator) {
      navigator.serviceWorker
        .register("/v4/twa/sw.js", { scope: "/v4/twa/" })
        .catch(console.error);
    }
  }, []);

  return (
    <>
      <Helmet>
        <link rel="manifest" href="/v4/twa/manifest.json" />
        <meta name="theme-color" content="#0f172a" />
      </Helmet>

      {children}

    </>
  );
}